import { queryApi } from "src/utils/api/ApiMethods"

export const getLedger = ({ marinaSlug, ledgerId }) => {
  return queryApi(`/ledgers/${ledgerId}?marina_slug=${marinaSlug}`)
}
